import { jsx as _jsx } from "react/jsx-runtime";
var UserApps = function UserApps(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM6.693 10.55a.97.97 0 0 1 .974-.973c.52 0 .974.432.974.973a.97.97 0 0 1-.974.974.97.97 0 0 1-.974-.974Zm9.367-.973a.97.97 0 0 0-.974.973c0 .541.433.974.974.974a.97.97 0 0 0 .973-.974.97.97 0 0 0-.973-.973Zm-.365 2.64a1.127 1.127 0 0 0-1.597-.165c-.878.713-1.811.862-2.6.768-.826-.097-1.406-.448-1.564-.614-.438-.492-1.14-.455-1.563-.107-.526.434-.495 1.16-.124 1.591l.01.012.01.01c.366.395.978.766 1.692 1.022 1.47.528 3.61.611 5.554-.91.54-.417.57-1.142.182-1.607Z",
      fill: color
    })
  });
};
export default UserApps;